import React, { useEffect } from "react";
import { Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";

import useJDStore from "../../store/jd.store";
import { useLocation } from "react-router-dom";

import SelectionTable from "../SelectionTable";

import "./teamSelection.scss";
import useStatsStore from "../../store/stats.store";
import { OWNERSHIP_OPTIONS } from "../../helper/categoryconstants";
import { GetSourceOwner } from "../../helper/commonFunctions";

export default function AllSelections(props) {
  const navigate = useNavigate();

  const {getAllSelectionStats,allSelectionsJds,allSelections,allSelectionsResumes} = useStatsStore()

  useEffect(() => {
    getAllSelectionStats("All");
  }, []);

  const titleList = [
    "Sr. No.",
    "Job ID", 
    "Client",
    "TA",
    "Job Title",
    "Name",
    "Email",
    "Mobile",
    "Selection Status",
    "Selection Date",
    "DoJ",
    "Offered CTC",
    "Assigned To",
    "Ownsership",
    "Owner Name",
    "Submitted On",
    "Resume Source",
    "Ownership Status",
  ]

  
  const GetTeamAssignment =(jds)=>{
    var assignedTeam=''
    jds?.JDAssignment?.Assignments?.map((assign,idx)=>{
      if (assignedTeam === ''){
        assignedTeam = assign.AssignedToName;
      }else{
        assignedTeam = assignedTeam +','+assign.AssignedToName;
      }
      
     return })

     return assignedTeam
  }

  function getJd(jdID){
    var foundjd = null
    allSelectionsJds?.map((jd)=>{
      if (jdID === jd.QhCompanyJID){
        foundjd=jd
      }
  
    })
    return foundjd
  }

  function GetResumeDetails(qhrid){
    for(let idx = 0; idx < allSelectionsResumes?.length; idx++){  
        if (allSelectionsResumes[idx]?.qhrid === qhrid) {
            return (
              allSelectionsResumes[idx]
        ) 
       }
     }
   }

    const allSelectionData = allSelections?.map((appDetail, idx) => {
      var jds = getJd(appDetail?.qhcompanyjid);
      var thisresume = GetResumeDetails(appDetail?.qhrid)
      var sOwner =GetSourceOwner(appDetail)
      return {
        id: idx + 1, 
        jobId: jds?.QhCompanyJID,
        client_name: jds?.JDClient.ClientName,
        ta_name: jds?.JDClient.TaName,
        title: jds?.JDDetails.Title,
        name: appDetail?.applicationid.name,
        email: appDetail?.applicationid.email, 
        phone: appDetail?.applicationid.mobile, 
        sStatus: appDetail?.selectionstatus?.status?appDetail?.selectionstatus?.status:"--",
        sDate:   appDetail?.selectionstatus?.updatedby.updatedon,
        eDoJ: appDetail?.newemploymentdetails?.finaldoj,
        oCTC: appDetail?.newemploymentdetails?.octc?.totalctc,
        assigned_to: GetTeamAssignment(jds),    
        method: OWNERSHIP_OPTIONS.find((option) => option.value === appDetail?.sourcingdetails?.method)?.label || "Unknown",
        sName:sOwner.sourceName,
        dateAdded: sOwner.sourceDate,            
        sourceMedium: thisresume?.firstuploadedby?.resumesource !== "By Candidate" ? thisresume?.firstuploadedby?.resumesource : "NuJobs",
        resumeownership:thisresume?.firstuploadedby?.resumeownership
      };
    });

  return (
    <div className="jds-wrapper">
      {allSelectionData?.length > 0 ? (
        <SelectionTable
          isClickable={true}
          isJDPage={true}
          titleList={titleList}
          data={allSelectionData}
        />
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
    </div>
  );
}
